const C = {
  name: "EarPods",
  dimensions: { width: 28, height: 41 },
  content: `
    <g clip-path="url(#clip0_12_5182)">
    <path d="M6 10.0029C4.93 10.0029 3.93 9.58293 3.17 8.83293C2.42 8.07293 2 7.07293 2 6.00293C2 3.79293 3.79 2.00293 6 2.00293C8.21 2.00293 10 3.79293 10 6.00293C10 8.21293 8.21 10.0029 6 10.0029ZM4 13.0029C4 13.5529 3.55 14.0029 3 14.0029C2.45 14.0029 2 13.5529 2 13.0029V10.4629C2.59 10.9929 3.27 11.3929 4 11.6529V13.0029ZM6 0.00292969C2.69 0.00292969 0 2.69293 0 6.00293V13.0029C0 14.3029 0.84 15.4029 2 15.8229V39.0029C2 39.5529 2.45 40.0029 3 40.0029C3.55 40.0029 4 39.5529 4 39.0029V15.8229C5.16 15.4029 6 14.3029 6 13.0029V12.0029C9.31 12.0029 12 9.31293 12 6.00293C12 2.69293 9.31 0.00292969 6 0.00292969Z" fill="currentColor"/>
    <path d="M22 10.0029C20.93 10.0029 19.93 9.58293 19.17 8.83293C18.42 8.07293 18 7.07293 18 6.00293C18 3.79293 19.79 2.00293 22 2.00293C24.21 2.00293 26 3.79293 26 6.00293C26 8.21293 24.21 10.0029 22 10.0029ZM20 13.0029C20 13.5529 19.55 14.0029 19 14.0029C18.45 14.0029 18 13.5529 18 13.0029V10.4629C18.59 10.9929 19.27 11.3929 20 11.6529V13.0029ZM22 0.00292969C18.69 0.00292969 16 2.69293 16 6.00293V13.0029C16 14.3029 16.84 15.4029 18 15.8229V39.0029C18 39.5529 18.45 40.0029 19 40.0029C19.55 40.0029 20 39.5529 20 39.0029V15.8229C21.16 15.4129 22 14.3129 22 13.0029V12.0029C25.31 12.0029 28 9.31293 28 6.00293C28 2.69293 25.31 0.00292969 22 0.00292969Z" fill="currentColor"/>
    </g>
    <defs>
    <clipPath id="clip0_12_5182">
    <rect width="28" height="40" fill="currentCOlor" transform="translate(0 0.00292969)"/>
    </clipPath>
    </defs>

  `
};
export {
  C as EarPods
};
